import React from "react";
import SdgVisualization from "../../molecules/SdgVisualization";
import AveragePriceChart from "../../molecules/AveragePriceChart";
import HighestAmount from "../../molecules/HighestAmount";
import MostDemanded from "../../molecules/MostDemanded";

const Graphs = () => {
  return (
    <>
      <div className=" w-full mt-[0] flex flex-col">
        <div className="flex p-4">
          <div className="w-[55%] h-full p-2">
            <AveragePriceChart />
            <SdgVisualization />
          </div>

          <div className="w-[45%] h-full p-2">
            <HighestAmount />
            <MostDemanded />
          </div>
        </div>
      </div>
    </>
  );
};
export default Graphs;
